import typhoonMapTypes from './types/typhoonMap'
import typhoonMapService from '@/api/typhoonMap'

const state = {}

const actions = {
  /**
   * 台风数据
   */
  [typhoonMapTypes.GET_TYPHOON_ACTIVITY] ({ commit }, { tfid = '' }) {
    return new Promise((resolve, reject) => {
      typhoonMapService.getTyhoonActivity({ tfid }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 台风详情
  [typhoonMapTypes.GET_TYPHOON_INFO] ({ commit }, { tfid = '' }) {
    return new Promise((resolve, reject) => {
      typhoonMapService.getTyphoonInfo({ tfid }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 雷达图
  [typhoonMapTypes.GET_WEATHER_RADAR] ({ commit }) {
    return new Promise((resolve, reject) => {
      typhoonMapService.getweatherRadar().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 卫星云图
  [typhoonMapTypes.GET_CLOUD_PIC] ({ commit }, { num = '1' }) {
    return new Promise((resolve, reject) => {
      typhoonMapService.getCloudPic({ num }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
